import { isBefore } from 'date-fns'

type Args = {
  startDate: number | null
  endDate: number | null
}

export const dateChecker = ({ startDate, endDate }: Args) => {
  if (startDate == null || endDate == null) return { startDate, endDate }
  return isBefore(startDate, endDate)
    ? { startDate, endDate }
    : { endDate: startDate, startDate: endDate }
}
